export const CARD_IMAGES = {
  VISA: 'visa.png',
  MASTERCARD: 'mastercard.png',
  AMEX: 'amex.png',
  DISCOVER: 'discover.png',
  DINA: 'dina.png',
  MAESTRO: 'maestro.png',
  DINERS: 'diners.png',
  DEFAULT: 'default.png'
}
